<template>
    <div class="badge-level" data-testid="profile-rqth-badge">
        <VJoyTooltip event="click">
            <span class="badge-level__content">
                <VJoyIcon name="user" size="xsmall" class="joy-color-brand-secondary-30" />
                <span class="badge-level__pill">RQTH</span>
            </span>
            <template #tooltip-content>{{ tooltip }}</template>
        </VJoyTooltip>
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {useTranslation} from '#imports';
    import {VJoyIcon, VJoyTooltip} from '@maltjoy/core-vue';

    const {t} = useTranslation();

    const tooltip = computed<string>(() => t('profile.card.badge.rqth.tooltip'));
</script>

<style scoped lang="scss">
    .badge-level {
        display: flex;
        align-items: center;

        &__content {
            display: inline-flex;
            align-items: center;
            cursor: pointer;
        }

        &__pill {
            display: inline-block;
            vertical-align: middle;
            box-sizing: border-box;
            height: 20px;
            padding: 3px 4px 4px;
            margin-left: var(--joy-core-spacing-2);
            border-radius: var(--joy-core-radius-1);
            background-color: var(--joy-color-neutral-20);
            color: var(--joy-color-brand-secondary-30);
            font-size: var(--joy-font-size-primary-200);
            line-height: var(--joy-line-height-small);
            white-space: nowrap;
        }
    }
</style>
